import HeaderAdmin from '../components/HeaderAdmin';
import LeftSideBarAdmin from '../components/LeftSideBarAdmin';
import './admin-buttons.css';
import FloatingSupportWidget from '~/components/FloatingSupportWidget';
import { HeaderNotificationListener } from '~/components/HeaderNotification';
import { GlobalPipelineProgressProvider } from '~/contexts/GlobalPipelineProgressContext';
import { GlobalPipelineProgressBar } from '~/components';

import { useEffect } from 'react';

function AdministratorLayout({ children }) {
    useEffect(() => {
        document.body.classList.add('administrator-layout');
        return () => {
            document.body.classList.remove('administrator-layout');
        }
    }, []);

    return (
        <GlobalPipelineProgressProvider>
            <main className='main administrator-layout'>
                <GlobalPipelineProgressBar />
                <LeftSideBarAdmin />
                <HeaderAdmin />
                <div className='content'>
                    <div className="px-4" style={{ paddingTop: '20px' }}>
                        <HeaderNotificationListener />
                    </div>
                    {children}
                </div>
                <FloatingSupportWidget />
            </main>
        </GlobalPipelineProgressProvider>
    )
}
export default AdministratorLayout;